var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 12 12",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M2 1h2m1 0h2m1 0h2M2 2h1m1 0h1m2 0h1m1 0h1M2 3h1m6 0h1M2 4h1m6 0h1M2 5h8M3 6h1m4 0h1M3 7h1m4 0h1M3 8h1m4 0h1M3 9h1m4 0h1m-6 1h1m4 0h1m-6 1h2m2 0h2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5d553f",
    d: "M3 2h1m1 0h1M3 3h3M3 4h3M4 6h2M4 7h2M4 8h1M4 9h1m-1 1h1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#353844",
    d: "M6 2h1m1 0h1M6 3h3M6 4h3M6 6h2M6 7h2M7 8h1M7 9h1m-1 1h1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#191919",
    d: "M5 8h2M5 9h2m-2 1h2m-2 1h2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTower);
export default __webpack_public_path__ + "static/media/tower.6fc08836eef6a550a39983ea2232a4c2.svg";
export { ForwardRef as ReactComponent };